import Request from '../../../../src/core/gd/data/request'

import DatetimeUtils from "../utils/datetime-utils"
import {ScheduleStatus} from "../types/types"
// import Task from "../../model2/task/task"

// @ts-ignore
import ScheduleManager from '../../../../src/core/model2/task/functions/schedule-manager'
import StatusUpdateRequestModel from "../../gd-modals/task-status-update/form-model";
import Task from "../../model2/task/task";
import Reminder from "../../model2/reminder/reminer"
import UserToAdd from "../../gd-modals/users/model/add-user"

export default class ApiTask {

    constructor() {

    }

    newTask(data: any) {
        /*{
            title:          result.title,
            project:        parentProjectId,
            companyId:      this.project.companyId,
            type:           taskType.id,
            parentTask:     parentTaskId,
            user:           actionRequiredUserId,
            priority:       result.priority,
            statusId:       tas.statusId,
            scheduleStatus: task.scheduleStatus,
            scheduleDate:       task.scheduleDate,
            planningStartDate:      task.planningStartDate,
            planningEndDate:        task.planningEndDate,
        }*/

        if (data.deadline && typeof data.deadline == "object") data.deadline = data.deadline.format("YYYY-MM-DD");

        // normalize dates
        if (data.planningStartDate) data.planningStartDate = moment(data.planningStartDate).format("YYYY-MM-DD");
        if (data.planningEndDate) data.planningEndDate = moment(data.planningEndDate).format("YYYY-MM-DD");

        const { scheduleDate } = ScheduleManager.calculateScheduleDate(data.companyId,data.planningStartDate,data.planningEndDate,data.scheduleDate,true);
        if (scheduleDate) {
            data.scheduleStatus = gd.const.task.scheduleStatus.SCHEDULED;
            data.scheduleDate = scheduleDate.format("YYYY-MM-DD");
        }

        return new Request(this, 'post', 'new-task', data);
    }

    // SUB TASKS

    newSubtask(parentTaskId: ID, companyId: ID, projectId: ID, title: string, taskTypeId: ID, userId: ID) {


        const params = {
            // attachments: [],
            companyId: companyId,
            // customFieldsData: [],
            // deadline: null,
            // estimate: null,
            // files: [],
            // fromUser: null,
            // message: "",
            parentTask: parentTaskId,
            // priority: null,
            project: projectId,
            scheduleDate: null,
            scheduleStatus: 0,
            // tags: [],
            title: title,
            type: taskTypeId,
            user: userId
            // ,
            // users: []
        };

        // if (result.deadline) result.deadline = Moment(result.deadline).format("YYYY-MM-DD");

        const request = new Request(this, 'post', 'new-task', params);

        request.fail(function (error) {
            gd.apiError(error);
        });

        return request;

    }

    statusUpdateRequest(task: Task, model: StatusUpdateRequestModel) {
        return new Request(this,'POST','task/'+task.id+"/status-update-request", {
            userId      : model.userId,
            message     : model.comments
        });
    }

    reminderCreate(task: Task, model: Reminder) {
        return new Request(this,'POST','task/{0}/reminder'.f(task.id), {
            name    : model.title,
            userId  : model.userId,
            date    : DatetimeUtils.momentToDate(model.date)
        });
    }

    // TASK USERS

    userDelete(taskId: ID, userId: ID) {
        return new Request(this,'DELETE','task/'+taskId+"/user/"+userId);
    }

    userAdd(taskId: ID, userId: ID) {
        return new Request(this,'PUT','task/'+taskId+'/users',{
            userId: userId
        });
    }

    addUsers(taskId: ID, arrUsers: any) {
        return new Request(this,'POST','task/{0}/users/add-many'.f(taskId),{
            arrUsers: arrUsers
        })
    }

    static createTaskUsers(taskId: ID, usersToCreate:UserToAdd[]) {
        const payload = _.map(usersToCreate, (userToAdd) => {
            return {
                access  : userToAdd.projectAccess,
                userId  : userToAdd.user.id,
                type    : 'project',
            }
        })

        return new Request(this, 'POST', 'task/{0}/users/add-many'.f(taskId), {
            arrUsers: payload
        })
    }

    userNotifications(taskId: ID, userId: ID, isNotificationsEnabled: boolean) {
        return new Request(this,'PUT','task/'+taskId+'/users/'+userId,{
            notifications: isNotificationsEnabled
        });
    }

    // Fields
    updateCustomFieldValue(taskId: ID, customFieldId: ID, value: any) {
        if (!taskId || !customFieldId) return;

        const customField = gd.session.customFields.get(customFieldId);
        return new Request(this,'put', 'task/' + taskId + '/custom-fields', {
            customFieldId: customFieldId,
            newValue: {
                type: customField.valueType,
                value: value
            },
            // value: value,
            // valueType: customField.valueType
        });

    }

    // OTHER

    saveChecklist(taskId: ID, checklist: any) {
        return new Request(this,'put','task/'+taskId+'/checklist',{
            'checklist': checklist
        });
    }

    setStatus(taskId: ID, statusId: ID, actionRequiredUserId?: ID | null) {

        let payload = {
            'status'                : statusId,
            'actionRequiredUser'    : actionRequiredUserId
        }

        gd.modules.validations.updateRequestPayloadOnTaskStatusChange(payload)

        return new Request(this,'put','task/'+taskId+'/status', payload);
    }

    view(taskId: ID) {
        return new Request(this,'GET','task/'+taskId);
    }

    setPriority(taskId: ID, priority: any, actionRequiredUserId?: ID) {
        if (!actionRequiredUserId) {
            return new Request(this,'put','task/'+taskId+'/priority',{
                'priority': priority
            });
        } else {
            return new Request(this,'put','task/'+taskId+'/priority',{
                'priority': priority,
                'actionRequiredUser': actionRequiredUserId
            });
        }
    }

    schedule(taskId: ID,scheduleDate: any) {
        return new Request(this,'post','task/'+taskId+"/schedule",{
            date: moment.isMoment(scheduleDate) ? DatetimeUtils.momentToDate(scheduleDate) : scheduleDate
        })
    }

    scheduleSomeday(taskId: ID) {
        return new Request(this,'post','task/'+taskId+"/schedule",{
            someday: true
        });
    }

    scheduleNotScheduled(taskId: ID) {
        return new Request(this,'post','task/'+taskId+"/schedule",{
            notScheduled: true
        });
    }

    planning(taskId: ID, params: any, requestDoneCallback: callback) {

        if (params.startDate) params.startDate = params.startDate.format("YYYY-MM-DD");
        if (params.endDate) params.endDate = params.endDate.format("YYYY-MM-DD");
        if (params.newScheduleDate) params.newScheduleDate = params.newScheduleDate.format("YYYY-MM-DD");


        const request = new Request(this,'put','task/'+taskId+"/planning",params);
        request.done(()=>{
            if (requestDoneCallback) requestDoneCallback(params);
        });

        return request

    }

    startEnd(taskId: ID, startMoment: Moment | null, endMoment: Moment | null, newScheduleDate: any, setScheduleDate: any, companyId: ID, calculationsDoneCallback?: callback, requestDoneCallback?: callback) {

        // startMoment,endMoment - new values
        // newScheduleDate

        const { startDate, endDate, scheduleDate } = ScheduleManager.calculateScheduleDate(companyId,startMoment,endMoment,newScheduleDate);
        if (calculationsDoneCallback) calculationsDoneCallback(startDate, endDate, scheduleDate);

        const params: any = {
            startDate:  startDate ? startDate.format("YYYY-MM-DD") : null,
            endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
            taskReset: true
        };

        if (setScheduleDate && scheduleDate) {
            params.newScheduleDate = scheduleDate.format('YYYY-MM-DD');
        }

        gd.modules.validations.updateRequestPayloadOnTaskStartEndDateChange(params)

        const request = new Request(this,'put','task/'+taskId+"/start-end",params);
        request.done(()=>{
            if (requestDoneCallback) requestDoneCallback(startDate, endDate, scheduleDate);
        });

        return request
    }

    startEndTimeAllocation(taskId: ID, startMoment: Moment, endMoment: Moment, newScheduleDate: any, removeSchedule: any, companyId: ID, timeAllocation: any, calculationsDoneCallback: callback) {
        const { startDate, endDate, scheduleDate } = ScheduleManager.calculateScheduleDate(companyId,startMoment,endMoment,newScheduleDate);
        if (calculationsDoneCallback) calculationsDoneCallback(startDate, endDate, scheduleDate);

        const params: any = {
            startDate:  startDate ? startDate.format("YYYY-MM-DD") : null,
            endDate: endDate ? endDate.format("YYYY-MM-DD") : null,
            taskReset: false,
            timeAllocation: timeAllocation
        };

        if (removeSchedule) params.newScheduleStatus = gd.const.task.scheduleStatus.NOT_SCHEDULED;
        else if (scheduleDate) params.newScheduleDate = scheduleDate.format('YYYY-MM-DD');

        const request = new Request(this,'put','task/'+taskId+"/start-end",params);
        request.done(()=>{});

        return request
    }

    setTimeAllocation(taskId: ID, timeAllocation: any) {
        return new Request(this,'put','task/'+taskId+"/time-allocation", {
            timeAllocation
        });
    }

    setDeadline(taskId: ID,deadlineDate: any) {
        return new Request(this,'PUT','task/'+taskId+"/deadline",{
            deadline: (deadlineDate)?deadlineDate.format("YYYY-MM-DD"):null
        });
    }

    setEstimate(taskId: ID,estimate: any,taskReset: boolean = true) {
        return new Request(this,'PUT', 'task/'+taskId+"/estimate",{
            estimate: estimate,
            taskReset: taskReset
        });
    }

    setProgress(taskId: ID,progress: any) {
        return new Request(this,'PUT', 'task/'+taskId+"/progress",{
            progress: progress
        });
    }

    reply(taskId: ID, values: any) {

        // this is a conversion + name pathch
        if (values.reportedDate) {
            values.timeReportDate = DatetimeUtils.momentToDate(values.reportedDate);
            delete values['reportedDate'];
        }

        // Update status dependency check
        if (_.has(values, 'status')) {
            gd.modules.validations.updateRequestPayloadOnTaskStatusChange(values)
        }




        return new Request(this,'POST','task/'+taskId+'/reply',values);
    }

    setARUser(taskId: ID, userId: ID, scheduleDate?: any) {
        const params: any = {
            actionRequiredUser: userId
        };

        if (scheduleDate) {
            params.scheduleStatus = gd.const.task.scheduleStatus.SCHEDULED
            params.scheduleDate = moment(scheduleDate).format("YYYY-MM-DD");
        }

        return new Request(this,'PUT','task/'+taskId+'/ar-user',params);
    }

    setAssignedToUser(taskId: ID, userId: ID | null) {
        return new Request(this,'PUT','task/'+taskId+'/assign-to-user',{
            'assignToUser': userId
        });
    }

    editTitle(taskId: ID, title: string) {
        return new Request(this, 'put', 'task/' + taskId + '/title', {
            title: title
        });
    }

    editTask(taskId: ID, title: string, taskType: any, taskStatus: any) {
        return new Request(this, 'PUT', 'task/' + taskId, {
            title: title,
            taskType: taskType,
            taskStatus: taskStatus
        });
    }

    deleteTask(taskId: ID) {
        const request = new Request(this,'DELETE','task/'+taskId);

        request.done(response=>{
            gd.bus.triggerEvent("gd.event:delete-task", {taskId:taskId})
        });

        return request;
    }

    // RECURENCY

    recurrencyInfo(taskId: ID) {
        return new Request(this,'GET','task/'+taskId+"/recurrency");
    }

    recurrencyCreate(taskId: ID, params: any) {
        params.action = 'create';
        return new Request(this,'POST','task/'+taskId+"/recurrency",params);
    }

    recurrencyUpdate(taskId: ID, params: any) {
        // params.action = 'update';
        return new Request(this,'PUT','task/'+taskId+"/recurrency",params);
    }

    recurrencyDelete(taskId: ID) {
        return new Request(this,'DELETE','task/'+taskId+"/recurrency");
    }

    // MESSAGES
    updateMessage(taskId: ID, taskMessageId: ID, message: any, messageRTF: any, attachments: any, reportedMinutes?: any) {

        // this is patch because format is different :(
        let newAttachments = null;
        if (attachments && attachments.length>0) {
            newAttachments = attachments
            // newAttachments = attachments.map(attachment=>{
            //     return {
            //         fileId: attachment.fileId,
            //         fileName: attachment.name,
            //         storageProvider: attachment.storageProvider
            //     }
            // })
        }

        return new Request(this,'PUT','task/'+taskId+"/message/"+taskMessageId,{
            message: message,
            messageRTF: messageRTF,
            attachments: newAttachments,
            reportedMinutes: reportedMinutes
        });
    }

    deleteMessage(taskId: ID, taskMessageId: ID) {
        return new Request(this,'DELETE','task/'+taskId+"/message/"+taskMessageId);
    }

    logView(taskId: ID) {
        return new Request(this, 'PUT', 'task/' + taskId + '/views');
    }

    addTag(taskId: ID, tagId: ID) {
        return new Request(this,'POST','task/' + taskId + '/tag/' + tagId);
    }

    removeTag(taskId: ID, tagId: ID) {
        return new Request(this,'DELETE','task/' + taskId + '/tag/' + tagId);
    }

    bulkRemoveTag(tasks: any, tagId: ID) {
        return new Request(this,'POST','bulk-tasks/untag/' + tagId,{
            tasks: tasks
        });
    }

    //dependencies
    addDependency(type: any, task1Id: ID, task2Id: ID) {
        /*{
            "type": //one of gd.const.gantt.linkTypes;
            "task2Id":  dependency.task1Id,
            // "project2Id": dependency.project1Id,
            "task1Id":  dependency.task2Id,
            // "project1Id": dependency.project2Id,
        };*/

        return new Request(this,'POST','dependencies', {type, task1Id, task2Id});
    }

    removeDependency(type: any, task1Id: ID, task2Id: ID) {
        /*{
            "type": //one of gd.const.gantt.linkTypes;
            "task2Id":  dependency.task1Id,
            // "project2Id": dependency.project1Id,
            "task1Id":  dependency.task2Id,
            // "project1Id": dependency.project2Id,
        };*/

        return new Request(this,'DELETE','dependencies?type='+type+'&task1Id='+task1Id+'&task2Id='+task2Id);
    }

    //copy
    copyToProject(taskId: ID, data: any) {

        /*const data = {
            toProjectId: result.parentProject,
            title: result.title,
            user: user,

            copyDescription: copyOptions.includes("description"),
            copyTags: copyOptions.includes("tags"),
            copyCustomFields: copyOptions.includes("customFields"),

            deadline: deadline ? deadline.format("YYYY-MM-DD") : null,
            planningStartDate: startDate ? startDate.format("YYYY-MM-DD") : null,
            planningEndDate: endDate ? endDate.format("YYYY-MM-DD") : null,

            copySubTasks: copyOptions.includes("copySubtasks") ? this.subTasks.map(t=>{
                return {
                    taskId: t.id,
                    user: t.assignedToUserId,
                    planningStartDate: null,
                    planningEndDate: null
                }
            }) : [],
        };*/

        return new Request(this,'POST','task/'+taskId+'/copy-to-project', data)
    }

    getSubtasks(taskId: ID) {
        return new Request(this,'GET','task/'+taskId+'/copy-to-project')
    }

    originalEmail(taskId: ID, taskMessagesId: ID) {
        return new Request(this,'GET','email-view',{
            taskId: taskId,
            taskMessagesId: taskMessagesId
        })
    }

    checkSubtasks(taskId: ID) {
        return new Request(this,'GET','task/'+taskId+'/count-subtasks');
    }

    update(taskId: ID, params: any) {

        // patch for schedule otherwise api error...
        if (params.scheduleStatus === ScheduleStatus.NOT_SCHEDULED || params.scheduleStatus === ScheduleStatus.SOMEDAY) {
            delete params['scheduleDate']
        }
        if (params.scheduleDate) {
            delete params['scheduleStatus']
        }

        // patch
        if (!_.isNil(params.statusId)) {
            params.taskStatusId = params.statusId
            delete params.statusId
        }

        // convert
        if (!_.isNil(params.scheduleDate)) {
            params.scheduleDate = DatetimeUtils.momentToDate(params.scheduleDate)
        }
        if (!_.isNil(params.deadline)) {
            params.deadline = DatetimeUtils.momentToDate(params.deadline)
        }
        if (!_.isNil(params.startDate)) {
            params.startDate = DatetimeUtils.momentToDate(params.startDate)
        }
        if (!_.isNil(params.endDate)) {
            params.endDate = DatetimeUtils.momentToDate(params.endDate)
        }

        // VALIDATION
        if (_.has(params, 'statusId') || _.has(params, 'taskStatusId')) {
            gd.modules.validations.updateRequestPayloadOnTaskStatusChange(params)
        }
        if (_.has(params, 'scheduleDate') && !(_.has(params, 'startDate') || _.has(params, 'startDate'))) {
            // console.log( "        if (_.has(params, 'scheduleDate') && !(_.has(updateData, 'startDate') || _.has(updateData, 'startDate'))) {"   )
            gd.modules.validations.updateRequestPayloadOnScheduleChange(params)
        }
        if (_.has(params, 'startDate') || _.has(params, 'startDate')) {
            gd.modules.validations.updateRequestPayloadOnTaskStartEndDateChange(params)
        }

        return new Request(this,'PUT','task/{0}/update'.f(taskId), params);
    }

    select(taskIds: ID[], params?: any) {
        return new Request(this,'POST','tasks/select', _.assign({taskIds}, params));
    }

    history(taskId: ID) {
        return new Request(this,'GET','task/'+taskId+'/history')
    }

    /*static statusUpdateRequest(task: Task, params: {userId: ID}) {
        return new Request(this,'GET','task/{0}/status-update-request'.f(task.id), {userId: params.userId})
    }*/

    /*static reminderRequest(task: Task, params: {name: string, userId: ID, date: Moment}) {
        const requestParams = {
            name    : params.name,
            userId  : params.userId,
            date    : DatetimeUtils.momentToDate(params.date)
        }

        return new Request(this,'GET','task/{0}/create-reminder'.f(task.id), requestParams)
    }*/
}
